import React from 'react';
import './Footer.scss';

const Footer: React.FC = () => {
  return (
    <footer className='global-footer'>
      © 懒熊体育 版权所有 复制必究 京ICP备2023029148号-1
    </footer>
  );
};

export default Footer;
